import { Col, Row } from "../../../GridV2";
import Action from "./Action";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MainActions = function MainActions(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    action = _ref.action,
    action2 = _ref.action2,
    action3 = _ref.action3,
    isDark = _ref.isDark,
    totalInnerCols = _ref.totalInnerCols;
  return /*#__PURE__*/_jsx(Row, {
    className: "flex flex-col-reverse sm:flex-row md:flex-col-reverse lg:flex-row",
    totalCols: totalInnerCols,
    children: /*#__PURE__*/_jsxs(Col, {
      xs: totalInnerCols.xs,
      sm: type === 'm-form' ? totalInnerCols.sm : totalInnerCols.sm - 2,
      md: type === 'm-form' ? totalInnerCols.md : totalInnerCols.md - 2,
      offset: type === 'm-form' ? 0 : {
        sm: 1
      },
      className: "flex flex-col items-center",
      children: [action && /*#__PURE__*/_jsx(Action, {
        type: type,
        action: action,
        actionType: "1",
        isDark: isDark,
        className: action2 || action3 ? 'mb-24' : ''
      }), action2 && /*#__PURE__*/_jsx(Action, {
        type: type,
        action: action2,
        actionType: "2",
        isDark: isDark,
        className: action3 ? 'mb-32' : ''
      }), action3 && /*#__PURE__*/_jsx(Action, {
        type: type,
        action: action3,
        actionType: "3",
        isDark: isDark
      })]
    })
  });
};
export default MainActions;